import React from "react"
import { Text } from "@chakra-ui/layout"
import { Image } from "@chakra-ui/image"
import SharedStack from "~components/shared/wrappers/shared-stack"

import EzyVetGlobalSupportGroup from "~images/pages/landing/ezyvet-global-support-group/ezv-gsg-logo.jpg"

export default function EzyVetGlobalSupportGroupPartnerInfo() {
    return (
        <SharedStack spacing={4} align="center">
            <Image
                rounded="md"
                src={EzyVetGlobalSupportGroup}
                alt="EzyVet Global Support Group Logo"
                w={340}
            />
            <Text textAlign="center" fontSize="md" fontWeight="medium">
                ezyVet Support Group Members get an additional 10% off their
                setup fee.
            </Text>
        </SharedStack>
    )
}
